export const electronicDrawing = {
  // Hero Banner
  heroTitleLine1: '一站式电子图纸',
  heroTitleLine2:
    '<span class="color-blue">可信自动化处理</span>解决方案',
  heroSubTitle: '让您的图纸处理更智能、更快速、更精准、更可信',
  tagTraceable: '可追溯',
  tagAuditable: '可审计',
  consultNow: '立即咨询',
  viewDetail: '查看详情',
  modalTitle: '咨询电子图纸解决方案',

  // 标签
  tagSdkEngine: 'SDK 核心引擎',
  tagDwgToPdf: 'DWG转PDF SDK',
  tagCadExport: 'CAD图纸一键导出',

  // 核心产品
  coreProductsTitleL1: '核心产品',
  coreProductsTitleL2: '覆盖全链路图纸处理场景',
  coreProduct1Title: '图纸精准渲染',
  coreProduct1Desc: '线条、标注、图层信息完全保留，像素级还原原图精度',
  coreProduct2Title: '智能识别图幅',
  coreProduct2Desc:
    '标准图幅、加长图幅、旋转图幅均可自动识别，无需人工干预',
  coreProduct3Title: '不同图幅混导',
  coreProduct3Desc:
    '同一张图纸中的不同图幅支持一起导出，一键完成批量处理',

  // 智能化处理平台
  platformSubLabel: '智能化处理平台',
  platformTitleL1: '智能电子图纸处理平台',
  platformTitleL2: 'Intelligent Digital Drawings Processing Platform',
  platformSubTitle:
    'CAD/PDF图纸智能标签体系 + 可信高质量数据处理系统',

  platformFeature1Title: '支持两大行业',
  platformFeature1Desc: '深度覆盖房屋建筑 & 机械制造',

  platformFeature2Title: '智能拆分图框',
  platformFeature2Desc: '同一张图纸中的不同图幅支持一起拆分',

  platformFeature3Title: '智能提取结构化信息',
  platformFeature3Desc:
    '包括但不限于标题栏信息、明细栏信息、连通域等',

  platformFeature4Title: '智能标签分类',
  platformFeature4Desc:
    '独创智能分类处理方法，最大程度消除AI幻觉',

  platformFeature5Title: '可信、少幻觉',
  platformFeature5Desc:
    '通过置信度评测、反馈体系和信息反查溯源，在充分享用AI的同时最大程度消除幻觉',

  // 企业服务
  enterpriseServiceTitleL1: '助力企业电子图纸数字化',
  enterpriseServiceTitleL2: '全程为您服务',
  serviceCard1Label: '实施迅速',
  serviceCard2Label: '专业团队',
  serviceCard3Label: '专业服务',
};
